import axios from "axios";
import React, { useEffect, useState } from "react";
import { MunicipalityNaneFrontSetting } from "../../../config";
import { loading, removeLoading } from "../../../Utils/Alert";
import { showGeojsonnew } from "../../Map/Layers/tempLayer";

export default function AdaParselArama() {
  const [ilceler, setIlceler] = useState([]);
  const [mahalleler, setMahalleler] = useState([]);
  const [selectedIlce, setSelectedIlce] = useState("");
  const [adaParsel, setAdaParsel] = useState([]);

  const getInfosFromNode = async () => {
    try {
      const response = await axios.get(
        MunicipalityNaneFrontSetting.nodeURL + "adres/get/ms_ilceler"
      );
      setIlceler(response.data.rows);
    } catch (error) {
      console.error("Error fetching ilceler:", error);
      alert("İlçe bilgileri getirilemedi.");
    }
  };
  const zoomToGeojsonKimlik = (geojson) => {
    showGeojsonnew(geojson);
  };
  const onChangeIlce = async (event) => {
    const ilceKodu = event.target.value;
    console.log(ilceKodu, "ilcekodu");
    setSelectedIlce(ilceKodu);

    try {
      const response = await axios.get(
        MunicipalityNaneFrontSetting.nodeURL +
          "adres/get/ms_mahalleler/" +
          ilceKodu
      );
      console.log(response.data.rows, "mahalleler");
      setMahalleler(response.data.rows);
    } catch (error) {
      console.error("Error fetching mahalleler:", error);
      alert("Mahalle Bilgileri Getirilemedi.");
    }
  };
  const AdaParselSorgula = () => {
    loading();
    let json = {
      adano: document.getElementById("adano").value,
      parselno: document.getElementById("parselno").value,
      mah: document.getElementById("mah").value,
      ilcekodu: document.getElementById("ilce_kodu").value,
    };
    console.log(json, "json");
    axios
      .post(MunicipalityNaneFrontSetting.nodeURL + `adres/get/ada/parsel/arama`, json)
      .then((res) => {
        console.log(res.data.rows, "adaparsel");
        if (res.data.rows.length === 0) {
          setAdaParsel([]);
          document.getElementById("noInfo").style.display = "block";
          document.getElementById("tableClass").style.display = "none";
        } else {
          setAdaParsel(res.data.rows);
          document.getElementById("noInfo").style.display = "none";
          document.getElementById("tableClass").style.display = "block";
        }
      })
      .catch((err) => {
        console.error(err);
        alert("Sorgulama sırasında bir hata oluştu.");
      })
      .finally(() => {
        removeLoading();
      });
  };

  useEffect(() => {
    console.log(adaParsel, "adaPa");
    console.log(ilceler, "ilceler");

    return () => {};
  }, [adaParsel, ilceler]);

  useEffect(() => {
    getInfosFromNode();
  }, []);

  return (
    <div className="container">
      <div className="row mb-3">
        <div className="col-md-12">
          <div className="row align-items-center">
            <label className="col-md-3">İlçe</label>
            <div className="col-md-9">
              <select
                id="ilce_kodu"
                className="form-control form-control-sm"
                onChange={onChangeIlce}
                value={selectedIlce}
              >
                <option value="" disabled>
                  Seçiniz
                </option>
                {ilceler.map((d, i) => (
                  <option key={i} value={d.kod}>
                    {d.ad}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="row align-items-center">
            <label className="col-md-3">Mahalle</label>
            <div className="col-md-9">
              <select
                id="mah"
                disabled={!selectedIlce}
                className="form-control form-control-sm"
              >
                <option value="">Seçiniz</option>
                {mahalleler.map((d, i) => (
                  <option key={i} value={d.kod}>
                    {d.tapumahallead}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="row align-items-center">
            <label className="col-md-3">Ada</label>
            <div className="col-md-9">
              <input
                id="adano"
                type="text"
                className="form-control form-control-sm"
              />
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="row align-items-center">
            <label className="col-md-3">Parsel</label>
            <div className="col-md-9">
              <input
                id="parselno"
                type="text"
                className="form-control form-control-sm"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12 d-flex justify-content-end">
          <button
            className="btn btn-warning btn-sm"
            onClick={AdaParselSorgula}
            id="adresTespitBtn"
          >
            Sorgula
          </button>
        </div>
      </div>
      <div
        id="noInfo"
        style={{
          display: adaParsel.length === 0 ? "block" : "none",
          textAlign: "center",
          marginTop: "10px",
          background: "#5BA9FF",
          borderRadius: "10px",
        }}
      >
        Bilgi Bulunamadı
      </div>
      <div
        id="tableClass"
        style={{
          borderRadius: "10px",
          border: "1px solid white",
          display: adaParsel.length > 0 ? "block" : "none",
          height:
            "40vh" /* Yüksekliği viewport yüksekliğinin %70'i olarak ayarla */,
          width: "100%" /* Genişliği %100 olarak ayarla */,
          paddingBottom: "5px",
          marginTop: "10px",
          overflowY: "scroll" /* İçeriğin kaydırılabilir olmasını sağlar */,
          scrollbarWidth: "none" /* Firefox için kaydırma çubuğunu gizler */,
          msOverflowStyle:
            "none" /* Internet Explorer ve Edge için kaydırma çubuğunu gizler */,
        }}
      >
        <table
          className="table table-sm table-bordered table-hover "
          style={{ width: "100%" }}
        >
          <thead>
            <tr
              style={{
                fontSize: "12px",
                position: "sticky",
                top: "0",
                backgroundColor: "#0F3C51",
              }}
            >
              <th>No</th>
              <th>İlçe Adı</th>
              <th>Mahalle Ad</th>
              <th colSpan={2}>Tapu Cinsi</th>
            </tr>
          </thead>
          <tbody style={{ fontSize: "10px" }}>
            {adaParsel.map((d, i) => {
              const ilce = ilceler.find((z) => z.kod === parseInt(d.ilceref));
              const ilceAdi = ilce ? ilce.ad : "Bilgi Yok";
              return (
                <tr key={i}>
                  <td>{d.tapukimlikno || "Bilgi Yok"}</td>
                  <td>{ilceAdi}</td>
                  <td>{d.tapumahallead || "Bilgi Yok"}</td>
                  <td>{d.tapucinsaciklama}</td>
                  <td style={{ width: "40px" }}>
                    <button
                      type="button"
                      onClick={() => zoomToGeojsonKimlik(d.g_as_text)}
                      style={{ fontSize: "10px" }}
                      className="btn btn-warning btn-sm text-dark"
                    >
                      Detay
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
